module.exports = __webpack_public_path__ + "logo_txz.jpg?cf6d93d325409f8108d0a474ef96ffdf";